import './UploadCostarFile.scss';
import Component from './UploadCostarFile.js';
export default Component;
